<template>
  <v-container fluid grid-list-xl pt-0>
    <v-toolbar flat height="50" class="v-toolbar-header">
      <v-toolbar-title>
        <v-flex pl-4 class="d-flex align-center">
          <v-combobox
            class="width-300 text-xs-left"
            name="bonusComplianceType"
            v-validate="'required'"
            :error-messages="errors.collect('select.bonusComplianceType')"
            v-model="bonusComplianceType"
            :items="items"
            flat
            item-text="title"
            :allow-overflow="false"
            type="button"
            single-line
            return-object
          >
            <template slot="selection" slot-scope="data">
              <div>
                <span style="color:#005cae">{{data.item.title}}</span>
              </div>
            </template>
          </v-combobox>
        <!-- 124840 Tutorial ingreso automático de facturas -->
        <a href="#" @click.prevent="showManualModal = true" style="color: #005cae; text-decoration: none; margin-left: 4rem; font-size: 14px;">
            <v-icon small class="fas fa-hand-point-right mr-1 mb-1"></v-icon>
            Tutorial para ingreso automático de facturas
          </a>
        </v-flex>
        
        <v-dialog v-model="showManualModal" max-width="600px">
          <v-card>
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Ingreso automático de Facturas</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="showManualModal = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text style="height: 380px;">
              <iframe width="560" height="315" src="https://www.youtube.com/embed/ARThFuES_Bc?si=Nf9whtGMulcWZ160" title="Ingreso automático de facturas" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items style="margin-right: 1.5% !important;" v-if="bonusComplianceType">
        <v-btn
          class="hidden-xs-only"
          style="height:50%;margin-left: 5% !important;"
          small
          v-if="bonusComplianceType.id==1 && showButtonGenerate"
          @click="sendBonusCompliancePreliquidationGeneration"
          color="accent"
        >Generar</v-btn>
        <v-btn
          class="hidden-xs-only"
          :disabled="$refs.preAproveList.selectedValue!=null?false:true"
          style="height:50%;margin-right: 3% !important;"
          small
          v-if="bonusComplianceType.id==2 && !bonusCompliancePermissionApproveAndBill&&$refs.preAproveList!=null"
          @click="sendBonusCompliancePreliquidationApprove"
          color="accent"
        >Aprobar</v-btn>
        <v-btn
          class="hidden-xs-only"
          :disabled="$refs.preAproveList.selectedValue!=null?false:true"
          style="height:50%;margin-right: 3% !important;"
          small
          v-if="bonusComplianceType.id==2 && bonusCompliancePermissionApproveAndBill&&$refs.preAproveList!=null"
          @click="sendBonusCompliancePreliquidationApprove"
          color="accent"
        >Aprobar</v-btn><!-- 
        <v-btn
          :disabled="$refs.preAproveList.selectedValue!=null?false:true"
          class="hidden-xs-only"
          style="height:50%;margin-right: 3% !important;"
          small
          v-if="bonusComplianceType.id==2 && bonusCompliancePermissionApproveAndBill&&$refs.preAproveList!=null"
          @click="sendBonusCompliancePreliquidationApproveAndBill()&&$refs.preAproveList!=null"
          color="accent"
        >Aprobar y facturar</v-btn> -->
        <v-btn
          :disabled="$refs.preAproveList.selectedValue!=null?false:true"
          class="hidden-xs-only"
          style="height:50%;margin-right: -1.6% !important;"
          small
          v-if="bonusComplianceType.id==2&&$refs.preAproveList!=null"
          @click="sendBonusCompliancePreliquidationReject"
          color="accent"
        >Rechazar</v-btn>

        <v-menu style="margin-left: 4% !important;" bottom left>
          <v-btn slot="activator" icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
          <v-list>
            
            <v-list-tile
              class="hidden-xs-only"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="bonusComplianceType.id==2 && bonusCompliancePermissionApproveAndBill&&$refs.preAproveList!=null"
              @click="sendBonusCompliancePreliquidationApproveAndBill()"
            >
            <v-list-tile-title>Aprobar y facturar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              class="hidden-xs-only"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="bonusComplianceType.id==2 && $refs.preAproveList!=null"
              @click="sendBonusComplianceDetail()"
            >
            <v-list-tile-title>Ver Detalle</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="generateExcel">
              <v-list-tile-title>Generar archivo excel</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="generatePDF">
              <v-list-tile-title>Generar archivo pdf</v-list-tile-title>
            </v-list-tile>

            <v-list-tile class="hidden-sm-and-up" v-if="bonusComplianceType.id==1 && showButtonGenerate">
              <v-list-tile-title @click="sendBonusCompliancePreliquidationGeneration">Generar</v-list-tile-title>
            </v-list-tile>

            <v-list-tile
              class="hidden-sm-and-up"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="bonusComplianceType.id==2 && !bonusCompliancePermissionApproveAndBill&&$refs.preAproveList!=null"
              @click="sendBonusCompliancePreliquidationApprove"
            >
              <v-list-tile-title >Aprobar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              class="hidden-sm-and-up"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="bonusComplianceType.id==2 && bonusCompliancePermissionApproveAndBill&&$refs.preAproveList!=null"
               @click="sendBonusCompliancePreliquidationApprove"
            >
              <v-list-tile-title>Aprobar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              class="hidden-sm-and-up"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              v-if="bonusComplianceType.id==2 && bonusCompliancePermissionApproveAndBill&&$refs.preAproveList!=null"
               @click="sendBonusCompliancePreliquidationApproveAndBill()"
            >
              <v-list-tile-title
               
              >Aprobar y facturar</v-list-tile-title>
            </v-list-tile>
            <v-list-tile
              class="hidden-sm-and-up"
              v-if="bonusComplianceType.id==2&&$refs.preAproveList!=null"
              :disabled="$refs.preAproveList.selectedValue!=null?false:true"
              @click="sendBonusCompliancePreliquidationReject"
            >
              <v-list-tile-title >Rechazar</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <preliquidation-generation v-if="bonusComplianceType && bonusComplianceType.id==1"></preliquidation-generation>
    <preliquidation-approval
      ref="preAproveList"
      v-if="bonusComplianceType && bonusComplianceType.id==2"
    ></preliquidation-approval>
    <liquidation-query ref="liqQuery" v-if="bonusComplianceType && bonusComplianceType.id==3"></liquidation-query>
  </v-container>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { downloadPDF } from "@/common/helpers/helpers";
import { downloadEXCEL } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import router from "@/router";

import PreliquidationGeneration from "./PreliquidationGeneration.vue";
import PreliquidationApproval from "./PreliquidationApproval.vue";
import LiquidationQuery from "./LiquidationQuery.vue";
import DetailLiquidation from "./DetailLiquidation.vue";

export default {
  components: {
    PreliquidationGeneration,
    PreliquidationApproval,
    LiquidationQuery,
    DetailLiquidation
  },
  computed: {
    ...mapGetters([
      "bonusComplianceSelected",
      "bonusCompliancePermissionApproveAndBill",
      "bonusCompliancePendingPdf",
      "bonusCompliancePendingExcel",
      "bonusCompliancePdf",
      "bonusComplianceExcel",
      "userId",
      "isBrokerBonusCompliance"
    ])
  },
  async mounted() {
    this.$store.dispatch("getUserId");
    this.bonusComplianceType = this.items[0];
    this.$store.dispatch("bonusCompliancePreliquidationValidatePermission");
    await this.$store.dispatch("validateIsUserAgentBonusCompliance", this.userId);
    this.showButtonGenerate = this.isBrokerBonusCompliance;
  },
  methods: {
    sendBonusCompliancePreliquidationGeneration() {
      this.$store
        .dispatch("sendBonusCompliancePreliquidationGeneration")
        .then(res => {
          this.$store.dispatch("getBonusCompliancePending");
        });
    },
    sendBonusCompliancePreliquidationApprove() {
      if (this.$refs.preAproveList.selectedValue != null) {
        this.$store
          .dispatch(
            "sendBonusCompliancePreliquidationApprove",
            this.$refs.preAproveList.selectedValue
          )
          .then(res => {
            if (res) {
              this.$refs.preAproveList.refresh();
            }
          });
      } else {
        this.$root.$emit(
          "showSnackBar",
          "Debe seleccionar el bono por cumplimiento",
          "error"
        );
      }
    },
    sendBonusCompliancePreliquidationApproveAndBill() {
      if (this.$refs.preAproveList.selectedValue != null) {
        this.$store
          .dispatch(
            "sendBonusCompliancePreliquidationApproveAndBill",
            this.$refs.preAproveList.selectedValue
          )
          .then(res => {
            if (res) {
              this.$refs.preAproveList.refresh();
            }
          });
      } else {
        this.$root.$emit(
          "showSnackBar",
          "Debe seleccionar el bono por cumplimiento",
          "error"
        );
      }
    },
    sendBonusCompliancePreliquidationReject() {
      if (this.$refs.preAproveList.selectedValue != null) {
        this.$store
          .dispatch(
            "sendBonusCompliancePreliquidationReject",
            this.$refs.preAproveList.selectedValue
          )
          .then(res => {
            if (res) {
              this.$refs.preAproveList.refresh();
            }
          });
      } else {
        this.$root.$emit(
          "showSnackBar",
          "Debe seleccionar el bono por cumplimiento",
          "error"
        );
      }
    },
    generatePDF() {
      switch (this.bonusComplianceType.id) {
        case 1:
          console.log("Case 1" +this.bonusComplianceType.id)
          this.$store.dispatch("getBonusCompliancePendingPdf").then(res => {
            if (this.bonusCompliancePendingPdf.byteLength < 100) {
              this.$root.$emit(
                "showSnackBar",
                "Error generando el pdf", //this.bonusCompliancePendingPdf.data,
                "error"
              );
              return;
            }
            downloadPDF(this.bonusCompliancePendingPdf, "preliquidaciones.pdf");
          });
          break;
        case 2:
          console.log("Case 2" +  this.bonusComplianceType.id)
          if (this.$refs.preAproveList.selectedValue != null) {
            this.$store
              .dispatch(
                "getBonusCompliancePreliminarPdf",
                this.$refs.preAproveList.selectedValue
              )
              .then(res => {
                if (this.bonusCompliancePdf.byteLength < 100) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Error generando el pdf", //this.bonusCompliancePdf.data,
                    "error"
                  );
                  return;
                }
                downloadPDF(
                  this.bonusCompliancePdf,
                  `bonos-cumplimiento-detalles-${
                    this.$refs.preAproveList.selectedValue
                  }.pdf`
                );
              });
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar el bono por cumplimiento",
              "warning"
            );
          }

          break;
        case 3:
          if (this.$refs.liqQuery.selectedValue) {
            this.$store
              .dispatch(
                "getBonusCompliancePdf",
                this.$refs.liqQuery.selectedValue
              )
              .then(res => {
                if (this.bonusCompliancePdf.byteLength < 100) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Error generando el pdf", //this.bonusCompliancePdf.data,
                    "error"
                  );
                  return;
                }
                downloadPDF(
                  this.bonusCompliancePdf,
                  `bonos-cumplimiento-detalles-${
                    this.$refs.liqQuery.selectedValue
                  }.pdf`
                );
              });
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar el bono por cumplimiento",
              "warning"
            );
          }
          break;
      }
    },
    generateExcel() {
      switch (this.bonusComplianceType.id) {
        case 1:
          this.$store.dispatch("getBonusCompliancePendingExcel").then(res => {
            if (
              this.bonusCompliancePendingExcel.byteLength < 200 ||
              this.bonusCompliancePendingExcel.length < 200
            ) {
              this.$root.$emit(
                "showSnackBar",
                "Error generando el excel", //this.bonusCompliancePendingExcel.data,
                "error"
              );
              return;
            } else {
              downloadEXCEL(
                this.bonusCompliancePendingExcel,
                "bonos-cumplimiento-pendientes.xlsx"
              );
            }
          });
          break;
        case 2:
          if (this.$refs.preAproveList.selectedValue != null) {
            this.$store
              .dispatch(
                "getBonusComplianceExcel",
                this.$refs.preAproveList.selectedValue
              )
              .then(res => {
                if (this.bonusComplianceExcel.byteLength < 100) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Error generando el excel", //this.bonusComplianceExcel.data,
                    "error"
                  );
                  return;
                }
                downloadEXCEL(
                  this.bonusComplianceExcel,
                  `bonos-cumplimiento-detalles-${
                    this.$refs.preAproveList.selectedValue
                  }.xlsx`
                );
              });
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar el bono por cumplimiento",
              "warning"
            );
          }

          break;
        case 3:
          if (this.$refs.liqQuery.selectedValue) {
            this.$store
              .dispatch(
                "getBonusComplianceExcel",
                this.$refs.liqQuery.selectedValue
              )
              .then(res => {
                if (this.bonusComplianceExcel.byteLength < 100) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Error generando el excel", //this.bonusComplianceExcel.data,
                    "error"
                  );
                  return;
                }
                downloadEXCEL(
                  this.bonusComplianceExcel,
                  `bonos-cumplimiento-detalles-${
                    this.$refs.liqQuery.selectedValue
                  }.xlsx`
                );
              });
          } else {
            this.$root.$emit(
              "showSnackBar",
              "Debe seleccionar el bono por cumplimiento",
              "warning"
            );
          }
          break;
      }
    },
    sendBonusComplianceDetail(){
      if (this.$refs.preAproveList.selectedValue != null) {
        this.$store
          .dispatch(
            "sendBonusComplianceDetail",
            this.$refs.preAproveList.selectedValue
          )
          .then(res => {
            if (res) {
              this.$refs.preAproveList.refresh();
            }
          });
      } else {
        this.$root.$emit(
          "showSnackBar",
          "Debe seleccionar el bono por cumplimiento",
          "error"
        );
      }
    }
  },
  data() {
    return {
      items: [
        {
          id: 1,
          title: i18n.t("message.preliquidationGeneration")
        },
        {
          id: 2,
          title: i18n.t("message.preliquidationApproval")
        },
        {
          id: 3,
          title: i18n.t("message.liquidationQuery")
        }
      ],
      bonusComplianceType: undefined,
      showManualModal: false,
      showButtonGenerate: false
    };
  }
};
</script>